import { combineReducers } from 'redux';

import loading from 'modules/global/reducers/generic.loading';
import * as types from 'modules/vehicleCheckModels/actionTypes';
import { createReducer } from 'utils/ReduxUtils';

/**
 * @typedef {{
 *   loading: boolean,
 *   defaultId: string,
 * }} VehicleCheckModelsUIDefaultEntityReducer
 */

/**
 * @param {string} state
 * @param {FetchVehicleCheckModelsSuccessAction} action
 */
const getDefault = (state, { payload: { content } }) => {
  const defaultVCM = content.find(({ dealerId, groupId }) => !dealerId && !groupId);
  return defaultVCM?.id ?? state;
};

export default combineReducers({
  loading: loading(types.FETCH_DEFAULT_VEHICLE_CHECK_MODEL),
  defaultId: createReducer(null, {
    [types.FETCH_VEHICLE_CHECK_MODELS_SUCCESS]: getDefault,
    [types.FETCH_DEFAULT_VEHICLE_CHECK_MODEL_SUCCESS]: (_, { payload: { id } }) => id,
  }),
});
